export default Object.freeze({
  ProviderDisbursementActiveSignHubPermission:
    'provider.disbursement.activesignhub',
});
